import React, { useState, useEffect } from "react";
import GroupApi from "../../api/GroupApi";
import { showError, showSuccess } from "../../utils/toastUtils";

function EditDetails({ groupData, fetchGroups, clearSelection }) {
  const [group, setGroup] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (groupData) setGroup(groupData.group || "");
  }, [groupData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!group.trim()) {
      setErrors({ group: "Group is required" });
      return;
    }

    try {
      const payload = {
        id: groupData._id,
        group,
      };

      const res = await GroupApi.update(payload);

      if (res.code === 200) {
        showSuccess(res.message);

        const modalEl = document.getElementById("edit-group-modal");
      const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }

        if (fetchGroups) fetchGroups();
        if (clearSelection) clearSelection();
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">Edit Group</h4>
          <button type="button" className="btn-close" data-bs-dismiss="modal" id="closeOffcanvasBtn"/>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body container">
            <div className="mb-3">
              <label className="form-label">Group</label>
              <input
                type="text"
                className="form-control"
                value={group}
                onChange={(e) => setGroup(e.target.value)}
              />
              {errors.group && (
                <span className="text text-danger">{errors.group}</span>
              )}
              {errors.api && (
                <span className="text text-danger">{errors.api}</span>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={clearSelection}
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditDetails;
